<div class="payment-result-container">
  <div class="payment-result-card animate-fade-in">
    <div class="icon-container error">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="payment-icon">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
      </svg>
    </div>

    <h1 class="payment-title">{{ 'i18n.domain.payment-failed.title' | translate }}</h1>

    <p class="payment-message">
      {{ 'i18n.domain.payment-failed.message' | translate }}
    </p>

  </div>
</div>
